import React, { memo } from 'react';
import ReactDOM from 'react-dom';

interface MonthlyMomentDeleteDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export const MonthlyMomentDeleteDialog = memo(
  ({
    title,
    message,
    confirmLabel,
    onCancel,
    onConfirm
  }: MonthlyMomentDeleteDialogProps) =>
    ReactDOM.createPortal(
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 99999
        }}
        onClick={event => {
          if (event.target === event.currentTarget) {
            onCancel();
          }
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            borderRadius: '8px',
            padding: '30px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }}
        >
          <h2
            style={{
              color: '#000',
              fontFamily: "'Adobe Clean', Arial, sans-serif",
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: 1.3,
              margin: '0 0 16px 0'
            }}
          >
            {title}
          </h2>
          <p
            style={{
              color: '#6d6d6d',
              fontFamily: "'Adobe Clean', Arial, sans-serif",
              fontSize: '14px',
              lineHeight: 1.5,
              margin: '0 0 24px 0'
            }}
          >
            {message}
          </p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '12px'
            }}
          >
            <button
              type="button"
              onClick={onCancel}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '16px',
                background: '#e6e6e6',
                color: '#222222',
                fontFamily: "'Adobe Clean', Arial, sans-serif",
                fontSize: '14px',
                fontWeight: 700,
                border: 'none',
                padding: '6px 16px 8px 16px',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '16px',
                background: '#d7373f',
                color: '#ffffff',
                fontFamily: "'Adobe Clean', Arial, sans-serif",
                fontSize: '14px',
                fontWeight: 700,
                border: 'none',
                padding: '6px 16px 8px 16px',
                cursor: 'pointer'
              }}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>,
      document.body
    )
);
